/* Global VidyoClient objects */
import store from "../store";
import Utils from "../helpers/utils";
import ErrorService from "./ErrorService";
import ConsoleLogService from "./ConsoleLogService";

var vidyoConnector = null;
var vidyoMode = null;
var callBackObj;
var shareLocalShare;
var vidyoChatMessageObj = {};
var selectedCamera;
var selectedMic;
var selectedSpeaker;
window.onVidyoClientLoaded = onVidyoClientLoaded;
var isConnectorReady = false;
var vidyoComponentLoaded = false;
var isRegisterDevicesInvoked = false;
var logRegistered = false;
var netWarningProcessor = null;
var cameraMuted = false;
import router from "../router";

var logFileFilter =
  "all@VidyoDevelopment debug@VidyoClient debug@VidyoSDP debug@VidyoResourceManager all@VidyoSignaling";

function isVidyoInviteMessage(item) {
  //So far there is no way to understand if we've got a video session or just url...
  //That's the way we will go for now.

  if (
    !item ||
    !item.text ||
    item.text.indexOf(window.Vidyo_Identifier_SendInviteMessage) == -1
  )
    return false;
  return true;
}

function onVidyoClientLoaded(status) {
  Utils.log.debug("Vidyo: VidyoClient load state - " + status.state);
  if (status.state == "READY") {
    window.VC = new window.VidyoClientLib.VidyoClient("", () => {
      // After the VidyoClient is successfully initialized a global VC object will become available
      // All of the VidyoConnector gui and logic is implemented in VidyoConnector.js

      if (store.getters.widgetData.config.logFileFilter)
        logFileFilter = store.getters.widgetData.config.logFileFilter;
      Utils.log.debug("logFileFilter:" + logFileFilter);
      VC.CreateVidyoConnector({
        viewId: null, // Div ID where the composited video will be rendered, see VidyoConnector.html;
        viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default", // Visual style of the composited renderer
        remoteParticipants: 8, // Maximum number of participants to render
        logFileFilter: logFileFilter,
        logFileName: "",
        userData: "",
      })
        .then(function (vc) {
          isConnectorReady = true;
          Utils.log.debug("Vidyo: CreateVidyoConnector success");
          vidyoConnector = vc;

          if (
            store.getters.widgetData.videoNetWarningProps &&
            store.getters.widgetData.videoNetWarningProps.enableNetWarningCheck
          ) {
            netWarningProcessor = InitNetWarningProcessor(store);
          }
          // //check if safari
          // if (Utils.isSafari()) {
          //   let isDisableVP8 =
          //     store.getters.widgetData.videoConfig.isDisableVP8 !== undefined
          //       ? store.getters.widgetData.videoConfig.isDisableVP8
          //       : true;
          //   vidyoConnector.SetAdvancedConfiguration({
          //     disableVP8: isDisableVP8,
          //   });
          //   Utils.log.debug("Vidyo: isDisableVP8: " + isDisableVP8);
          // }
          //we want to test everything on the new router
          if (store.getters.widgetData.videoConfig.isSetPoolParameter == true) {
            vidyoConnector.SetPool({ name: "VR2C" });
            Utils.log.debug("Vidyo: SetPool: {name:'VR2C}");
          }

          setInterval(() => {
            Array.from(document.querySelectorAll("video")).forEach((el) => {
              el.setAttribute("playsinline", "playsinline");
            });
          }, 100);
          if (vidyoComponentLoaded) {
            vidyoConnector.AssignViewToCompositeRenderer({
              viewId: "renderer", // Div ID where the composited video will be rendered, see VidyoConnector.html;
              viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default", // Visual style of the composited renderer
              remoteParticipants: 8, // Maximum number of participants to render
            });

            if (callBackObj.onConnectorReady) {
              callBackObj.onConnectorReady();
            }
            registerDevices();
            callBackObj.muteDevices();
            if (ConsoleLogService.isEnabled()) registerLog();
            joinVidyoCall();
          }
        })
        .catch(function (error) {
          Utils.log.error("CreateVidyoConnector Failed " + error);
        });
    });
  }
}
///
//select local devices
///
function selectLocalCamera(localCamera) {
  Utils.log.debug(
    "Vidyo: on selectLocalCamera " + localCamera + localCamera.name
  );
  vidyoConnector.SelectLocalCamera({
    localCamera: localCamera,
  });
}
function selectLocalSpeaker(localSpeaker) {
  Utils.log.debug(
    "Vidyo: on selectLocalSpeaker " + JSON.stringify(localSpeaker)
  );
  vidyoConnector.SelectLocalSpeaker({
    localSpeaker: localSpeaker,
  });
}
function selectLocalMic(localMic) {
  Utils.log.debug(
    "Vidyo: on selectLocalMicrophone " + JSON.stringify(localMic)
  );
  vidyoConnector.SelectLocalMicrophone({
    localMicrophone: localMic,
  });
}
//change cams
function cycleCamera() {
  Utils.log.debug("Vidyo: on cycleCamera ");
  vidyoConnector.CycleCamera();
}

async function reSelectDevices() {
  if (selectedCamera) {
    Utils.log.debug("Vidyo: registerDevices reselecting camera " + selectedCamera.name);
    await selectLocalCamera(selectedCamera);
  }
  else {
    Utils.log.debug("Vidyo: registerDevices reselecting default camera");
    await vidyoConnector.SelectDefaultCamera();
  }
  if (selectedMic) {
    Utils.log.debug("Vidyo: registerDevices reselecting mic " + selectedMic.name);
    await selectLocalMic(selectedMic);
  }
  else {
    Utils.log.debug("Vidyo: registerDevices reselecting default mic");
    await vidyoConnector.SelectDefaultMicrophone();
  }
  if (selectedSpeaker) {
    Utils.log.debug("Vidyo: registerDevices reselecting speaker " + selectedSpeaker.name);
    await selectLocalSpeaker(selectedSpeaker);
  }
  else {
    Utils.log.debug("Vidyo: registerDevices reselecting default speaker");
    await vidyoConnector.SelectDefaultSpeaker();
  }

}

function registerDevices() {
  if (isRegisterDevicesInvoked) {
    Utils.log.debug(
      "Vidyo: registerDevices function already called - reselecting devices or defaults starting"
    );
    reSelectDevices().then(() => {
      Utils.log.debug(
        "Vidyo: registerDevices function already called - reselecting devices or defaults completed"
      );  
    });

    return;
  }
  isRegisterDevicesInvoked = true;
  Utils.log.debug("Vidyo: on register device");
  vidyoConnector
    .RegisterLocalCameraEventListener({
      onAdded: function (localCamera) {
        Utils.log.debug(
          "Vidyo: localCamera onAdded",
          JSON.stringify(localCamera)
        );
        callBackObj.onAddCamera(localCamera);
        let defaultCameraName =
          store.getters.widgetData.videoConfig.defaultCameraName || "FRONT";
        if (localCamera.name.toUpperCase().indexOf(defaultCameraName.toUpperCase()) > -1) {
          selectedCamera = localCamera;
          callBackObj.onSelectCamera(selectedCamera.name);
          selectLocalCamera(selectedCamera);
        }
      },
      onRemoved: function (localCamera) { },
      onSelected: function (localCamera) {
        Utils.log.debug(
          "Vidyo: localCamera onSelected",
          JSON.stringify(localCamera)
        );
        if (localCamera) {
          localCamera.SetPreviewLabel({
            previewLabel:
              store.state.appData.JoinChatData.Calling_User_FirstName,
          });
          if (store.getters.widgetData.config.cameraMode) {
            var isSetMaxConstraintSuccess = localCamera.SetMaxConstraint(
              store.getters.widgetData.config.cameraMode
            );

            if (isSetMaxConstraintSuccess) {
              Utils.log.debug(
                "Vidyo: SetMaxConstraint set to " +
                JSON.stringify(store.getters.widgetData.config.cameraMode)
              );
            } else {
              Utils.log.debug("Vidyo: SetMaxConstraint not set");
            }
          }
          selectedCamera = localCamera;
          callBackObj.onSelectCamera(localCamera.name);
        }
      },
      onStateUpdated: function (localCamera, state) { },
    })
    .then(function () {
      Utils.log.debug("Vidyo: RegisterLocalCameraEventListener Success");
      // if (selectedCamera) {
      //   callBackObj.onSelectCamera(selectedCamera.name);
      //   selectLocalCamera(selectedCamera);
      // }
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterLocalCameraEventListener Failed");
    });

  vidyoConnector
    .RegisterLocalMicrophoneEventListener({
      onAdded: function (localMicrophone) {
        Utils.log.debug("Vidyo: localMicrophone onAdded");
        callBackObj.onAddMic(localMicrophone);
        if (localMicrophone.name.toUpperCase().indexOf("DEFAULT") > -1) {
          selectedMic = localMicrophone;
          callBackObj.onSelectMic(selectedMic.name);
          selectLocalMic(selectedMic);
        }
      },
      onRemoved: function (localMicrophone) { },
      onSelected: function (localMicrophone) {
        if (localMicrophone) {
          selectedMic = localMicrophone;
          callBackObj.onSelectMic(localMicrophone.name);
        }
      },
      onStateUpdated: function (localMicrophone, state) { },
    })
    .then(function () {
      Utils.log.debug("Vidyo: RegisterLocalMicrophoneEventListener Success");
      // if (selectedMic) {
      //   callBackObj.onSelectMic(selectedMic.name);
      //   selectLocalMic(selectedMic);
      // }
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterLocalMicrophoneEventListener Failed");
    });

  vidyoConnector
    .RegisterLocalSpeakerEventListener({
      onAdded: function (localSpeaker) {
        Utils.log.debug("Vidyo: localSpeaker onAdded");
        callBackObj.onAddSpeaker(localSpeaker);
        if (localSpeaker.name.toUpperCase().indexOf("DEFAULT") > -1) {
          selectedSpeaker = localSpeaker;
          callBackObj.onSelectSpeaker(selectedSpeaker.name);
          selectLocalSpeaker(selectedSpeaker);
        }
      },
      onRemoved: function (localSpeaker) { },
      onSelected: function (localSpeaker) {
        if (localSpeaker) {
          selectedSpeaker = localSpeaker;
          callBackObj.onSelectSpeaker(localSpeaker.name);
        }
      },
      onStateUpdated: function (localSpeaker, state) { },
    })
    .then(function () {
      Utils.log.debug("Vidyo: RegisterLocalSpeakerEventListener Success");
      // if (selectedSpeaker) {
      //   callBackObj.onSelectSpeaker(selectedSpeaker.name);
      //   selectLocalSpeaker(selectedSpeaker);
      // }
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterLocalSpeakerEventListener Failed");
    });

  vidyoConnector
    .RegisterParticipantEventListener({
      onJoined: function (participant) {
        Utils.log.debug(
          "Vidyo: Participant Joined ",
          JSON.stringify(participant)
        );
      },
      onLeft: function (participant) {
        Utils.log.debug(
          "Vidyo: Participant Left ",
          JSON.stringify(participant)
        );
        if (participant.isLocal) {
          Utils.postMessageObject("vidyo", { participantLeft: participant });
        }
      },
      onDynamicChanged: function (participants) {
        Utils.log.debug(
          "Vidyo: Ordered array of participants according to rank ",
          participants
        );
        if (store.getters.widgetData.config.isKioskNoChatUntilVideo) {
          for (let p of participants) {
            if (p.isLocal == false) {
              store.commit("setAgentArrivedToVideo", true);
            }
          }
        }
        // if (participants.length == 1 && participants[0].isLocal) {
        //   Utils.log.debug("Vidyo: Left only me on conversation...");
        // }
        /* Ordered array of participants according to rank */
      },
      onLoudestChanged: function (participant, audioOnly) {
        /* Current loudest speaker */
        Utils.log.debug(
          "Vidyo: onLoudestChanged",
          JSON.stringify(participant),
          JSON.stringify(audioOnly)
        );
      },
    })
    .then(function () {
      Utils.log.debug("Vidyo: RegisterParticipantEventListener Success");
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterParticipantEventListener Failed");
    });

  vidyoConnector
    .RegisterLocalWindowShareEventListener({
      onAdded: function (localWindowShare) {
        shareLocalShare = localWindowShare;
      },
      onRemoved: function (localWindowShare) {
        // stopShareCallback();
      },
      onSelected: function (localWindowShare) {
        if (!localWindowShare) {
          callBackObj.onStopShare();
        }
      },
      onStateUpdated: function (localWindowShare, state) {
        // stopShareCallback();
      },
    })
    .then(function (result) {
      if (result) {
        Utils.log.debug("Vidyo: RegisterLocalWindowShareEventListener Success");
      } else {
        Utils.log.error("Vidyo: RegisterLocalWindowShareEventListener Failed");
      }
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterLocalWindowShareEventListener Failed");
    });

  if (store.getters.widgetData.config.showAudioMeters !== undefined) {
    Utils.log.debug(
      "Vidyo: ShowAudioMeters=" +
      store.getters.widgetData.config.showAudioMeters
    );
    vidyoConnector.ShowAudioMeters({
      viewId: "renderer",
      showMeters: store.getters.widgetData.config.showAudioMeters,
    });
  }

  //vidyoConnector.AddMessageClass();
  vidyoConnector.RegisterMessageEventListener({
    onChatMessageAcknowledged: (message) => { },
    onChatMessageReceived: (participant, message) => {
      if (
        message.body.startsWith("SpecialMessage::") &&
        message.body.includes("MobileModeChange")
      ) {
        // parse state value if needed
        let state = null;
        try {
          state = JSON.parse(atob(message.body.split("MobileModeChange|")[1]));
        } catch (e) { }
        // here is logic to trigger camera off/on or on/off
        if (state === null || state.state === "f") {
          const timeout =
            store.getters.widgetData.videoConfig.cameraRestartTimeout ? store.getters.widgetData.videoConfig.cameraRestartTimeout : 2000;
          setTimeout(() => {
            vidyoConnector
              .SetCameraPrivacy({
                privacy: !cameraMuted,
              })
              .then(() => {
                vidyoConnector
                  .SetCameraPrivacy({
                    privacy: cameraMuted,
                  })
                  .catch(() => { });
              })
              .catch(() => { });
          }, timeout);
        }
      }
    },
  });
}

function registerLog() {
  Utils.log.debug(
    "Vidyo: on register log, already registered = " + logRegistered
  );
  if (logRegistered == true) return;
  vidyoConnector
    .RegisterLogEventListener({
      filter: store.getters.widgetData.config.logFileFilter,
      onLog: function (vidyoLogRecordObj) {
        ConsoleLogService.addToCollectedLogs(vidyoLogRecordObj.level, [
          "VidyoLog:" + JSON.stringify(vidyoLogRecordObj),
        ]);
      },
    })
    .then(function (result) {
      if (result) {
        Utils.log.debug("Vidyo: RegisterLogEventListener Success");
        logRegistered = true;
      } else {
        Utils.log.error("Vidyo: RegisterLogEventListener Failed");
      }
    })
    .catch(function () {
      Utils.log.error("Vidyo: RegisterLogEventListener Failed");
    });
}

var endVidyoCall = function () {
  Utils.log.debug("Vidyo: on endVidyoCall");

  if (vidyoConnector && vidyoConnector.HideView) {
    vidyoConnector.HideView({ viewId: "renderer" });
  }
  setLocalDevices(true);
  store.commit("setVideoLoader", false);
  store.commit("setCurrentView", "chat");
  store.commit("setVideoMessage", null);

  //if still connected to chat - don't remove the listeners & destruct
  // if (
  //   store.state.appData.DataGlobal.connId &&
  //   store.state.appData.DataGlobal.connId !== -1
  // ) {
  //   Utils.log.debug("Vidyo: don't continue to unregister & destruct connector");
  //   return;
  // }
  // if (vidyoConnector && vidyoConnector.UnregisterLocalCameraEventListener) {
  //   vidyoConnector.UnregisterLocalCameraEventListener();
  //   vidyoConnector.UnregisterLocalMicrophoneEventListener();
  //   vidyoConnector.UnregisterLocalSpeakerEventListener();
  //   vidyoConnector.UnregisterLocalWindowShareEventListener();
  //   vidyoConnector.UnregisterParticipantEventListener();
  //   // vidyoConnector.Destruct();
  // }

  netWarningProcessor && netWarningProcessor.stop();
};

function setLocalDevices(isNull) {
  if (vidyoConnector && vidyoConnector.SelectLocalCamera) {
    vidyoConnector.SelectLocalCamera({
      localCamera: isNull ? null : selectedCamera,
    });
    vidyoConnector.SelectLocalMicrophone({
      localMicrophone: isNull ? null : selectedMic,
    });
    vidyoConnector.SelectLocalSpeaker({
      localSpeaker: isNull ? null : selectedSpeaker,
    });
  }
}
var joinVidyoCall = function () {
  Utils.log.debug(`Vidyo: On joinVidyoCall - before vidyo connect:
    token ${vidyoChatMessageObj.token}
    display name: ${decodeURI(vidyoChatMessageObj.displayname)}
    host: ${vidyoChatMessageObj.host}
  `);
  if (vidyoMode.indexOf("VidyoPlatform") > -1) {
    Utils.log.debug(
      "vidyoChatMessageObj: ",
      JSON.stringify(vidyoChatMessageObj)
    );
    vidyoConnector.ConnectToRoomAsGuest({
      host: vidyoChatMessageObj.host, // Server name, for most production apps it will be prod.vidyo.io
      displayName: decodeURI(vidyoChatMessageObj.displayname), // Display name
      roomKey: vidyoChatMessageObj.roomkey,
      roomPin: vidyoChatMessageObj.pin ? vidyoChatMessageObj.pin : "",

      onSuccess: function () {
        onJoinSuccess();
      },
      onFailure: async function (reason) {
        if (vidyoConnector == null) {
          return;
        }
        Utils.log.error("Vidyo: onFailure (" + reason + ")");
        Utils.log.debug("Vidyo: isConnect = " + store.getters.isConnect);
        var ending = true;
        if (store.getters.isConnect == true) {
          if (reason && reason == "VIDYO_CONNECTORFAILREASON_Terminated") {
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoTerminated ||
              "Vidyo call terminated",
              "info"
            );
          } else if (isRejoining()) {
            ending = false;
            if (await waitForRejoin()) {
              joinVidyoCall();
              return;
            } else {
              ending = true;
            }
          } else {
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoFailure ||
              "Vidyo connector on failure"
            );
          }
        }

        if (ending == true) {
          endVidyoCall();
          // unregisterAllWithoutDisconnect();
          Utils.postMessageObject("vidyo", {
            failure: {
              reason: reason,
              roomKey: vidyoChatMessageObj.roomkey,
            },
          });
        }
      },
      onDisconnected: async function (reason) {
        Utils.log.info("Vidyo: onDisconnected (" + reason + ")");
        Utils.log.debug("Vidyo: isConnect = " + store.getters.isConnect);
        if (
          reason &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Disconnected" &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Terminated" &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Booted" &&
          store.getters.isConnect == true
        ) {
          if (!isRejoining()) {
            // Failed to connect
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoFailure ||
              "Vidyo connector on failure"
            );
          } else {
            Utils.log.debug(
              "Vidyo: Room disconnected - " +
              reason +
              " - failed to rejoin, retrying..."
            );
            if (await waitForRejoin()) {
              joinVidyoCall();
              return;
            }
          }
        }
        Utils.log.debug("Vidyo: Room disconnected - " + reason);
        // disconnectVidyoCall("Vidyo connector disconnected");
        endVidyoCall();
        // unregisterAllWithoutDisconnect();
        Utils.postMessageObject("vidyo", {
          disconnected: {
            reason: reason,
            roomKey: vidyoChatMessageObj.roomkey,
          },
        });
      },
    });
  } else {
    vidyoConnector.Connect({
      host: vidyoChatMessageObj.host, // Server name, for most production apps it will be prod.vidyo.io
      token: vidyoChatMessageObj.token,
      displayName: decodeURI(vidyoChatMessageObj.displayname), // Display name
      resourceId: vidyoChatMessageObj.resourceid, // Room name
      onSuccess: function () {
        onJoinSuccess();
      },
      onFailure: async function (reason) {
        if (vidyoConnector == null) {
          return;
        }
        Utils.log.error("Vidyo: onFailure (" + reason + ")");
        Utils.log.debug("Vidyo: isConnect = " + store.getters.isConnect);
        // disconnectVidyoCall(
        //   reason == "VIDYO_CONNECTORDISCONNECTREASON_Terminated"
        //     ? reason
        //     : "Vidyo connector on failure"
        // );
        var ending = true;
        if (store.getters.isConnect == true) {
          if (reason && reason == "VIDYO_CONNECTORFAILREASON_Terminated") {
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoTerminated ||
              "Video call terminated",
              "info"
            );
          } else if (isRejoining()) {
            ending = false;
            if (await waitForRejoin()) {
              joinVidyoCall();
              return;
            } else {
              ending = true;
            }
          } else {
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoFailure ||
              "Vidyo connector on failure"
            );
          }
        }
        if (ending == true) {
          endVidyoCall();
          // unregisterAllWithoutDisconnect();
          Utils.postMessageObject("vidyo", {
            failure: {
              reason: reason,
              roomKey: vidyoChatMessageObj.roomkey,
            },
          });
        }
      },
      onDisconnected: async function (reason) {
        Utils.log.info("Vidyo: onDisconnected (" + reason + ")");
        Utils.log.debug("Vidyo: isConnect = " + store.getters.isConnect);
        if (
          reason &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Disconnected" &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Terminated" &&
          reason != "VIDYO_CONNECTORDISCONNECTREASON_Booted" &&
          store.getters.isConnect == true
        ) {
          if (!isRejoining()) {
            // Failed to connect
            ErrorService.displayAlert(
              store.getters.widgetData.errorAlerts.vidyoFailure ||
              "Vidyo connector on failure"
            );
          } else {
            Utils.log.debug(
              "Vidyo: disconnected - " +
              reason +
              " - failed to rejoin, retrying..."
            );
            if (await waitForRejoin()) {
              joinVidyoCall();
              return;
            }
          }
        }
        Utils.log.debug("Vidyo: Room disconnected - " + reason);
        // disconnectVidyoCall("Vidyo connector disconnected");
        endVidyoCall();
        // unregisterAllWithoutDisconnect();
        Utils.postMessageObject("vidyo", {
          disconnected: {
            reason: reason,
            roomKey: vidyoChatMessageObj.roomkey,
          },
        });
      },
    });
  }
};

function isRejoining() {
  Utils.log.debug("Vidyo: isConnect = " + store.getters.isConnect);
  Utils.log.debug(
    "Vidyo: vidyoRetryAttempts = " +
    store.state.vidyoRetryAttempts +
    " of " +
    store.getters.widgetData.config.vidyoRejoinAttempts
  );
  var rejoining =
    store.getters.isConnect == true &&
    store.getters.widgetData.config.vidyoRejoinAttempts &&
    store.getters.widgetData.config.vidyoRejoinAttempts > 0 &&
    (!store.state.vidyoRetryAttempts ||
      store.getters.widgetData.config.vidyoRejoinAttempts >
      store.state.vidyoRetryAttempts);
  Utils.log.debug("Vidyo: isRejoining = " + rejoining);
  return rejoining;
}

async function waitForRejoin() {
  if (store.getters.isConnect != true) return false;
  if (
    store.getters.widgetData.config.vidyoRejoinAttempts &&
    store.getters.widgetData.config.vidyoRejoinAttempts <=
    store.state.vidyoRetryAttempts
  ) {
    ErrorService.displayAlert(
      store.getters.widgetData.errorAlerts.vidyoFailureRejoin ||
      "Vidyo connector failure to rejoin"
    );
    return false;
  }
  if (
    store.getters.widgetData.errorAlerts.vidyoFailureRejoining &&
    store.getters.widgetData.errorAlerts.vidyoFailureRejoining !== ""
  ) {
    ErrorService.displayAlert(
      store.getters.widgetData.errorAlerts.vidyoFailureRejoining,
      "info"
    );
  }
  store.state.vidyoError = true;
  store.state.vidyoRetryAttempts = store.state.vidyoRetryAttempts + 1;
  Utils.log.info(
    "Vidyo: connection disconnected while chat connected, waiting upto 5s before rejoining"
  );
  let timeoutInstance;
  await new Promise((r) => {
    timeoutInstance = setTimeout(r, 5000);
  });
  clearTimeout(timeoutInstance);
  // Check if still connected after 5s wait
  if (store.getters.isConnect != true) return false;
  var vidyoState = await vidyoConnector.GetState();
  Utils.log.debug("Vidyo: state:" + vidyoState);
  if (vidyoState == "VIDYO_CONNECTORSTATE_Ready") {
    Utils.log.debug(
      "Vidyo: ready after disconnection for re-joining attempt " +
      store.state.vidyoRetryAttempts +
      " of " +
      store.getters.widgetData.config.vidyoRejoinAttempts
    );
    return true;
  }
  Utils.log.info("Vidyo: not ready after disconnection - not re-joining");
  // Reset retry flags, we're not retrying
  if (store.getters.isConnect == true) {
    ErrorService.displayAlert(
      store.getters.widgetData.errorAlerts.vidyoFailureRejoin ||
      "Vidyo connector on failure to rejoin"
    );
  }
  store.state.vidyoError = false;
  store.state.vidyoRetryAttempts = 0;
  return false;
}


function onJoinSuccess() {
  Utils.postMessageObject("vidyo", {
    joinSuccess: {
      roomKey: vidyoChatMessageObj.roomkey,
    },
  });
  store.commit("setVideoLoader", false);
  Utils.log.debug("Vidyo: room Connected!! YAY!");
  // If in retry keep settings
  if (!store.state.vidyoRetryAttempts || store.state.vidyoRetryAttempts == 0) {
    callBackObj.muteDevices();
  }
  store.state.vidyoError = false;
  store.state.vidyoRetryAttempts = 0;

  if (callBackObj.onJoinSuccess) {
    callBackObj.onJoinSuccess();
  }
  netWarningProcessor && netWarningProcessor.init();
}

var disconnectVidyoCall = function () {
  // endVidyoCall();
  if (vidyoConnector && vidyoConnector.Disconnect) {
    vidyoConnector
      .Disconnect()
      .then((e) => {
        Utils.log.debug("Vidyo: Disconnect Success", e);
      })
      .catch((e) => {
        Utils.log.debug(
          "Vidyo: Cannot Disconnect",
          e
            ? e
            : "Vidyo: Cannot disconnect - maybe you are already disconnected from vidyo"
        );
      });
  }
  // if (isUnregister) {
  //   unregisterAllWithoutDisconnect();
  // }
};

var setCameraPrivacy = function (privacy) {
  cameraMuted = privacy;
  return vidyoConnector
    .SetCameraPrivacy({
      privacy: privacy,
    })
    .then(function (res) {
      Utils.log.debug("Vidyo: Set camera privacy to " + privacy + " success");
      return res;
    })
    .catch(function () {
      Utils.log.error("Vidyo: Set camera privacy to " + privacy + " failed");
    });
};

var setMicPrivacy = function (privacy) {
  return vidyoConnector
    .SetMicrophonePrivacy({
      privacy: privacy,
    })
    .then(function (res) {
      Utils.log.debug(
        "Vidyo: Set microphone privacy to " + privacy + " success"
      );
      return res;
    })
    .catch(function (e) {
      Utils.log.error(
        "Vidyo: Set microphone privacy to " + privacy + " failed"
      );
      throw e;
    });
};

var startShare = function () {
  return vidyoConnector
    .SelectLocalWindowShare({
      localWindowShare: shareLocalShare,
    })
    .then(function (res) {
      if (res) {
        Utils.log.debug("Vidyo: localWindowShare: " + shareLocalShare.name);
        Utils.log.debug("Vidyo: Start SelectLocalWindowShare Success");
        return;
      }
      throw res;
    })
    .catch(function (e) {
      Utils.log.error("Vidyo: Start SelectLocalWindowShare Failed");
      throw e;
    });
};

var stopShare = function () {
  return vidyoConnector
    .SelectLocalWindowShare({
      localWindowShare: null,
    })
    .then(function () {
      Utils.log.debug("Vidyo: Stop SelectLocalWindowShare Success");
      return;
    })
    .catch(function (e) {
      Utils.log.error("Vidyo: Stop SelectLocalWindowShare Failed");
      throw e;
    });
};

var setSpeakerPrivacy = function (privacy) {
  if (!vidyoConnector || !vidyoConnector.SetSpeakerPrivacy) {
    Utils.log.error("Vidyo: cannot SetSpeakerPrivacy");
    return;
  }
  return vidyoConnector
    .SetSpeakerPrivacy({
      privacy: privacy,
    })
    .then(function () {
      Utils.log.debug("Vidyo: set speaker privacy to" + privacy + "Success");
      return;
    })
    .catch(function (e) {
      Utils.log.error("Vidyo: set speaker privacy failed");
      throw e;
    });
};

function initFromVidyoComponent(chatMessageObj, callBacks) {
  vidyoComponentLoaded = true;
  Utils.log.debug("Vidyo: VidyoService on init");
  callBackObj = Object.assign({}, callBacks);
  vidyoChatMessageObj = chatMessageObj;
  vidyoMode = chatMessageObj.mode;

  if (isConnectorReady) {
    Utils.log.debug("Vidyo: Already exist vidyoConnector");
    vidyoConnector.AssignViewToCompositeRenderer({
      viewId: "renderer", // Div ID where the composited video will be rendered, see VidyoConnector.html;
      viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default", // Visual style of the composited renderer
      remoteParticipants: 8, // Maximum number of participants to render
    });
    // callBackObj.onSelectCamera(selectedCamera.name);
    // selectLocalCamera(selectedCamera);
    if (callBackObj.onConnectorReady) {
      callBackObj.onConnectorReady();
    }
    registerDevices();
    callBackObj.muteDevices();
    if (ConsoleLogService.isEnabled()) registerLog();
    joinVidyoCall();
    // return;
  }
  // if (vidyoMode.indexOf("VidyoIO") > -1) {
  //   loadVidyoClientLibrary();
  // } else {
  // loadNativeScriptWebRTCVidyoClientLibrary();
  // }
}

function init() {
  if (!store.getters.widgetData.config.enableVideo) {
    Utils.log.debug(
      `VidyoService skipping init as enableVideo not true.`
    );
  } else {
    Utils.log.debug(
      `VidyoService init as enableVideo true.`
    );
      loadNativeScriptWebRTCVidyoClientLibrary();
  }
}

function loadNativeScriptWebRTCVidyoClientLibrary() {
  // Assumes that this file is hosted in the Hookflash build environment
  // TODO: update path
  if (document.getElementById("vcScript"))
    document.getElementById("vcScript").remove();
  var script = document.createElement("script");
  script.type = "module";
  script.id = "vcScript";
  script.src = `${location.protocol}//${store.getters.getWidgetHost}/${store.getters.IISAppName}/assets/VidyoClient.js`;
  script.onload = function () {
    onVidyoClientLoaded({
      state: "READY",
      description: "Native SCIP + WebRTC",
    });
  };
  document.getElementsByTagName("head")[0].appendChild(script);

  if (document.getElementById("vcStyle"))
    document.getElementById("vcStyle").remove();
  var style = document.createElement("link");
  style.id = "vcStyle";
  style.rel = "stylesheet";
  style.type = "text/css";
  style.href = `${location.protocol}//${store.getters.getWidgetHost}/${store.getters.IISAppName}/assets/VidyoClient.css`;
  document.getElementsByTagName("head")[0].appendChild(style);
}

function loadVidyoClientLibrary() {
  let webrtc = true;
  let plugin = false;

  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let isFirefox = userAgent.indexOf("Firefox") !== -1;
  let isChrome = userAgent.indexOf("Chrome") !== -1;

  if (isChrome || isFirefox) {
    /* Supports WebRTC */
    webrtc = true;
    plugin = false;
    Utils.log.debug("Vidyo: Either chrome or Firefox");
  } else {
    plugin = true;
    webrtc = false;
    Utils.log.debug("Vidyo: Not chrome or Firefox");
  }

  if (document.head.getElementById("vcScript"))
    document.head.getElementById("vcScript").remove();
  var script = document.createElement("script");
  script.type = "module";
  script.id = "vcScript";
  script.src = `https://static.vidyo.io/latest/javascript/VidyoClient/VidyoClient.js?onload=onVidyoClientLoaded&webrtc=${webrtc}&plugin=${plugin}`;
  document.getElementsByTagName("head")[0].appendChild(script);
}

const InitNetWarningProcessor = (store) => {
  const config = store.getters.widgetData.videoNetWarningProps;
  const CHECK_INTERVAL = config.checkInterval || 10000;
  const MAX_JITTER = config.maxJitter || 0.2;
  // only if remote camera enabled
  const MIN_NETWORK_RECEIVE_BITRATE = config.minNetworkReceiveBitrate || 400000;
  // only if we have local camera enabled
  const MIN_SEND_AVAILABLE_BANDWIDTH =
    config.minAvailableSendBandwidth || 400000;
  // we don't have percentage information of packets lost... only total value.. so let's try to use it somehow
  const PACKETS_LOST_AT_INTERVAL_PERIOD =
    config.packetsLostAtIntervalPeriod || 50;
  let timeout = null;
  let lastTotalPacketsLost = 0;

  const notify = (state, text) =>
    callBackObj.onNetWarning &&
    callBackObj.onNetWarning(state, text ? text : null);
  const process = async () => {
    let displayNetWarn = false;
    let warnToShow = "";
    try {
      const statsJson = await vidyoConnector.GetStatsJson();
      const statsObj = JSON.parse(statsJson);
      const roomStats = statsObj.userStats[0].roomStats[0];

      const currentSendBandwidthAvailable = roomStats.sendBitRateAvailable;
      const currentNetworkReceiveBitrate = roomStats.receiveBitRateTotal;
      const currentJitter = roomStats.participantStats.reduce(
        (sum, participantStats) => {
          return (
            sum +
            participantStats.remoteMicrophoneStats.reduce(
              (jitter, rmStats) => jitter + rmStats.receiveNetworkJitter,
              0
            )
          );
        },
        0
      );
      const currentTotalPacketsLost = roomStats.participantStats.reduce(
        (sum, participantStats) => {
          return (
            sum +
            participantStats.remoteMicrophoneStats.reduce(
              (packetsLost, rmStats) =>
                packetsLost + rmStats.receiveNetworkPacketsLost,
              0
            ) +
            participantStats.remoteCameraStats.reduce(
              (packetsLost, rcStats) =>
                packetsLost + rcStats.receiveNetworkPacketsLost,
              0
            )
          );
        },
        0
      );
      const hasRemoteVideoSource = roomStats.participantStats.some(
        (ps) => ps.remoteCameraStats.length > 0
      );
      const hasLocalVideoSource = statsObj.localCameraStats.length > 0;
      const packetsLostAtInterval =
        currentTotalPacketsLost - lastTotalPacketsLost;
      lastTotalPacketsLost = currentTotalPacketsLost;

      displayNetWarn =
        (hasRemoteVideoSource &&
          currentNetworkReceiveBitrate < MIN_NETWORK_RECEIVE_BITRATE) ||
        (hasLocalVideoSource &&
          currentSendBandwidthAvailable < MIN_SEND_AVAILABLE_BANDWIDTH) ||
        currentJitter > MAX_JITTER ||
        packetsLostAtInterval >= PACKETS_LOST_AT_INTERVAL_PERIOD;

      //determine warn message text
      if (
        currentJitter > MAX_JITTER ||
        packetsLostAtInterval >= PACKETS_LOST_AT_INTERVAL_PERIOD
      ) {
        warnToShow = store.getters.widgetData.videoNetWarningProps.warningLabel;
      }
      if (
        hasLocalVideoSource &&
        currentSendBandwidthAvailable < MIN_SEND_AVAILABLE_BANDWIDTH
      ) {
        warnToShow =
          store.getters.widgetData.videoNetWarningProps
            .warningLabelminAvailableSendBandwidth;
      }
      if (
        hasRemoteVideoSource &&
        currentNetworkReceiveBitrate < MIN_NETWORK_RECEIVE_BITRATE
      ) {
        warnToShow =
          store.getters.widgetData.videoNetWarningProps
            .warningLabelminNetworkReceiveBitrate;
      }
      ////
    } catch (e) { }
    notify(displayNetWarn, warnToShow);
    timeout = setTimeout(process, CHECK_INTERVAL);
  };
  return {
    init: () => {
      lastTotalPacketsLost = 0;
      timeout = setTimeout(process, CHECK_INTERVAL);
    },
    stop: () => {
      notify(false);
      clearTimeout(timeout);
      timeout = null;
    },
  };
};

function getJWTToken() {
  return vidyoConnector
    .GetJWTToken()
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      Utils.log.debug("Vidyo: getJWTToken Failed", error);
      return false;
    });
};

function unsubscribeFromTopic(token) {
  return vidyoConnector
    .UnsubscribeFromTopic({
      topicSubscriptionToken: token
    })
    .then(function (data) {
      return true;
    })
    .catch(function () {
      Utils.log.debug("Vidyo: UnsubscribeFromTopic Failed");
      return false;
    });
}

function subscribeToTopic(token, messageCallback, statusCallback) {
  return vidyoConnector
    .SubscribeToTopic({
      topicSubscriptionToken: token,
      messageCallback: messageCallback,
      statusCallback: statusCallback
    })
    .then(function (data) {
      return true;
    })
    .catch(function () {
      Utils.log.debug("Vidyo: SubscribeToTopic Failed");
      return false;
    });
};

let VidyoService = {
  init,
  initFromVidyoComponent,
  selectLocalCamera,
  selectLocalSpeaker,
  selectLocalMic,
  // removeLibrary,
  disconnectVidyoCall,
  setCameraPrivacy,
  setMicPrivacy,
  startShare,
  stopShare,
  cycleCamera,
  // unregisterAll,
  endVidyoCall,
  isVidyoInviteMessage,
  setLocalDevices,
  setSpeakerPrivacy,
  getJWTToken,
  unsubscribeFromTopic,
  subscribeToTopic
};
export default VidyoService;
